import { useCallback, useEffect, useState } from 'react'
import { Card, Col, Form, Row } from 'react-bootstrap'
import MenuItem from '@mui/material/MenuItem'
import { useDispatch } from 'react-redux'

/** TRANSLATION*/
import { useTranslation } from 'react-i18next'

/** STYLE */
import useStyles from 'features/setting/treatments/xray-film-types/style'

/** API */
import XrayFilmTypeApi from 'api/setting/treatments/xray-film-type.api'

/** UTILS || SLICE */
import { submitModal, unSubmitModal, showModal, resetModal } from 'app/slice/modal.slice'
import { isCreate, isDelete, isUpdate, isView } from 'utils/verification.utils'

/** COMPONENT */
import { swalActive } from 'component/Alert/Swal'
import ButtonCustom from 'component/Button/ButtonCustom'
import HeaderCard from 'component/CardCustom/HeaderCard'
import InputTextField from 'component/Input/InputTextField'
import InputTextSearch from 'component/Input/InputTextSearch'
import ModalCustom from 'component/ModalCustom/ModalCustom'
import TableCustom from 'component/Table/TableCustom'
import { notiSuccess, notiError } from 'component/notifications/notifications'
import TableRowCommon from 'component/Table/TableRowCommon'
import FilterSelect from 'component/Select/FilterSelect'
import AlertModal from 'new-components/modal/alert-modal'
import PageModal from 'new-components/modal/page-modal'
import { Box, Typography } from '@mui/material'
import SwitchButton from 'new-components/buttons/switch-button'
import TextInput from 'new-components/inputs/text-input'
import SnackbarComponent from 'new-components/snackbar/snackbar-component'

const permissions = {
  isCreate: isCreate(),
  isDelete: isDelete(),
  isUpdate: isUpdate(),
  isView: isView()
}

const initStateErrorMessage = {
  XRAY_FILM_TYPE_NAME: ``,
  IS_DUPLICATE_XRAY_FILM_TYPE_NAME: ``,
  XRAY_FILM_TYPE_NAME_STRING_BASE: ``,
  XRAY_FILM_TYPE_NAME_STRING_EMPTY: ``,
  XRAY_FILM_TYPE_NAME_MAXIMUM_LENGTH: ``,
  XRAY_FILM_TYPE_NAME_ANY_REQUIRED: ``,

  XRAY_FILM_TYPE_NAME_EN: ``,
  IS_DUPLICATE_XRAY_FILM_TYPE_NAME_EN: ``,
  XRAY_FILM_TYPE_NAME_EN_STRING_BASE: ``,
  XRAY_FILM_TYPE_NAME_EN_STRING_EMPTY: ``,
  XRAY_FILM_TYPE_NAME_EN_MAXIMUM_LENGTH: ``,
  XRAY_FILM_TYPE_NAME_EN_ANY_REQUIRED: ``
}

export default function XrayFilmTypes() {
  const classes = useStyles()
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const [xrayFilmTypes, setXrayFilmTypes] = useState([])

  const [xrayFilmTypeId, setXrayFilmTypeId] = useState(Number)
  const [xrayFilmTypeName, setXrayFilmTypeName] = useState('')
  const [xrayFilmTypeStatus, setXrayFilmTypeStatus] = useState('')

  const [errorMessage, setErrorMessage] = useState(initStateErrorMessage)

  const [isAlertDel, setIsAlertDel] = useState<number>(0)

  /** PAGINATION  */
  const [page, setPage] = useState(1)
  const [pageLimit, setPageLimit] = useState(10)
  const [rowCount, setRowCount] = useState(0)
  const [sortBy, setSortBy] = useState('createAt')
  const [sortType, setSortType] = useState('ASC')
  const [search, setSearch] = useState('')
  const [status, setStatus] = useState('ALL')

  const [isOpenAlertModal, setIsOpenAlertModal] = useState(false)
  const [statusAlertModal, setStatusAlertModal] = useState('')
  const [id, setId] = useState<number>(0)
  const [name, setName] = useState('')
  const [isOpenSnack, setIsOpenSnack] = useState(false)
  const [typeSnack, setTypeSnack] = useState<any>("success")
  const [labelSnack, setLabelSnack] = useState('')

  const [isOpen, setIsOpen] = useState(false)

  const loadData = useCallback(async () => {
    let condition: any = {}
    if (page) condition = { ...condition, page: page }
    if (pageLimit) condition = { ...condition, pageLimit: pageLimit }
    if (search) condition = { ...condition, search: search }
    if (sortBy) condition = { ...condition, sortBy: sortBy }
    if (sortType) condition = { ...condition, sortType: sortType }
    if (status) condition = { ...condition, status: status === 'ALL' ? '' : status }

    const res = await XrayFilmTypeApi.findAll(condition)
    if (res.status === 200) {
      setRowCount(res.headers['x-total'])
      setXrayFilmTypes(res.data)
    }
  }, [page, pageLimit, search, sortBy, sortType, status])

  useEffect(() => {
    loadData()
  }, [loadData])

  const submit = () => {
    if (!xrayFilmTypeName) return setErrorMessage({ ...errorMessage, ...{ XRAY_FILM_TYPE_NAME: t('XRAY_FILM_TYPE.MESSAGE.XRAY_FILM_TYPE_NAME') } })

    dispatch(submitModal())
    XrayFilmTypeApi.create({ xrayFilmTypeName })
      .then((res: any) => {
        if (res.status !== undefined && res.status === 201) {
          notiSuccess(t('XRAY_FILM_TYPE.MESSAGE.SUCCESS.CREATE'), '', null, null)
          resetForm()

          loadData()
          setIsOpen(false)
        } else {
          const err = res.response.data
          setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`XRAY_FILM_TYPE.MESSAGE.${err.message}`) } })
          setIsOpen(false)
        }
      })
      .catch((e) => {

        const err = e.response.data
        setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`XRAY_FILM_TYPE.MESSAGE.${err.message}`) } })
        setIsOpen(false)
      })
      .finally(() => {
        return

      })
  }

  const submitEdit = () => {
    if (!xrayFilmTypeName) return setErrorMessage({ ...errorMessage, ...{ XRAY_FILM_TYPE_NAME: t(`XRAY_FILM_TYPE.MESSAGE.XRAY_FILM_TYPE_NAME`) } })

    dispatch(submitModal())
    XrayFilmTypeApi.update(xrayFilmTypeId, {
      xrayFilmTypeName,
      status: xrayFilmTypeStatus
    })
      .then((res: any) => {
        if (res.status !== undefined && res.status === 200) {
          notiSuccess(t(`XRAY_FILM_TYPE.MESSAGE.SUCCESS.UPDATE`), '', null, null)
          resetForm()
          loadData()
          setIsOpen(false)
        } else {
          const err = res.response.data

          setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`XRAY_FILM_TYPE.MESSAGE.${err.message}`) } })
          setIsOpen(false)
        }
      })
      .catch((e) => {
        const err = e.response.data
        setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`XRAY_FILM_TYPE.MESSAGE.${err.message}`) } })
        setIsOpen(false)
      })

  }

  const clearErrorMessage = () => {
    setErrorMessage(initStateErrorMessage)
  }

  const resetForm = () => {
    setXrayFilmTypeId(0)
    setXrayFilmTypeName('')
    setXrayFilmTypeStatus('')
    clearErrorMessage()
    setIsOpen(false)
  }

  const onActive = () => {
    if (id) {
      XrayFilmTypeApi.updateStatus(id, statusAlertModal).then((resp) => {
        if (resp.status === 200) {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("success")
          setLabelSnack(t('XRAY_FILM_TYPE.MESSAGE.SUCCESS.UPDATE_STATUS'))
          loadData()
        } else {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("error")
          setLabelSnack(t('XRAY_FILM_TYPE.MESSAGE.ERROR'))
        }
      })
    }
  }
  const onDelete = async () => {
    if (id) {
      XrayFilmTypeApi.remove(id).then((resp) => {
        if (resp.status === 200) {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("success")
          setLabelSnack(t('XRAY_FILM_TYPE.MESSAGE.SUCCESS.DELETE'))
          loadData()
        } else {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("error")
          setLabelSnack(t('XRAY_FILM_TYPE.MESSAGE.ERROR'))
        }
      })
    }
  }

  const onEdit = (data: any) => {
    const { xrayFilmTypeId: id, xrayFilmTypeName: name, status: xrayTypeStatus } = data
    setXrayFilmTypeId(id)
    setXrayFilmTypeName(name)
    setXrayFilmTypeStatus(xrayTypeStatus)
    setIsOpen(true)
  }

  const onRequestSort = (sortByVal: string, sortTypeVal: string) => {
    setSortType(sortTypeVal)
    setSortBy(sortByVal)
  }

  const handleChangePage = (val: number) => {
    setPage(val)
  }

  const handleChangeRowsPerPage = (limit: number) => {
    setPageLimit(limit)
  }

  const handleChangeStatus = (statusVal: string) => {
    setStatus(statusVal)
  }

  const headCells = [
    { id: 'no', disablePadding: false, label: '#' },
    { id: 'xrayFilmTypeName', disablePadding: false, label: t('XRAY_FILM_TYPE.TABLE.CELL.XRAY_FILM_TYPE_NAME') },
    { id: 'status', disablePadding: false, label: t('XRAY_FILM_TYPE.TABLE.CELL.STATUS') },
    { id: 'updatedBy', disablePadding: false, label: t('XRAY_FILM_TYPE.TABLE.CELL.UPDATED_BY') },
    { id: 'action', disablePadding: false, label: 'Action' }
  ]

  const renderData = (objData: any, no: number) => {
    no = page * pageLimit - pageLimit + no + 1
    const { xrayFilmTypeId: id, xrayFilmTypeName: name, updatedBy, updatedAt, status: xrayTypeStatus } = objData
    const statusBtnActive = xrayTypeStatus === 'ACTIVE' ? true : permissions.isUpdate.disabled
    const statusBtnInActive = xrayTypeStatus === 'INACTIVE' ? true : permissions.isUpdate.disabled
    const objRenderData = {
      key: id,
      id: id,
      obj: objData,
      columns: [
        { option: 'TEXT', align: 'center', label: no },
        { option: 'TEXT', align: 'left', label: name },
        { option: 'STATUS', align: 'center', label: xrayTypeStatus },
        { option: 'UPDATE_BY', align: 'center', label: { updatedBy: updatedBy, updatedAt: updatedAt } },
        {
          option: 'ACTION',
          align: 'center',
          label: 'action',
          values: [
            { option: 'STATUS_ACTIVE', label: t(`STATUS.ACTIVE`), disabled: statusBtnActive },
            { option: 'STATUS_INACTIVE', label: t(`STATUS.INACTIVE`), disabled: statusBtnInActive },
            { option: 'DIVIDER', label: '', disabled: false },
            { option: 'EDIT', label: t(`BUTTON.EDIT`), disabled: permissions.isUpdate.disabled },
            { option: 'DELETE', label: t(`BUTTON.DELETE`), disabled: permissions.isDelete.disabled }
          ]
        }
      ]
    }
    return (
      <TableRowCommon
        {...objRenderData}
        onactive={() => handleSubmitModal(Number(objRenderData.id), 'ACTIVE', objRenderData.obj)}
        oninactive={() => handleSubmitModal(Number(objRenderData.id), 'INACTIVE', objRenderData.obj)}
        onedit={() => onEdit(objRenderData.obj)}
        ondelete={() => handleSubmitModal(Number(objRenderData.id), 'DELETE', objRenderData.obj)}
      />
    )
  }

  const handleSubmitModal = (id: number, status: string, obj?: any) => {
    setStatusAlertModal(status)
    setId(id)
    setIsOpenAlertModal(true)
    setName(obj.xrayFilmTypeName)
  }

  return (
    <div className={classes.root}>
      <AlertModal
        isOpen={isOpenAlertModal}
        title={t(`XRAY_FILM_TYPE.ALERT.${statusAlertModal === 'DELETE' ? 'TITLE_DELETE' : 'TITLE_ACTIVE'}`)}
        message={t(`XRAY_FILM_TYPE.ALERT.${statusAlertModal === 'DELETE' ? 'CONFIRM_DELETE_' : 'CONFIRM_STATUS'}`, { xrayFilmTypeName: name, status: t(`XRAY_FILM_TYPE.ALERT.${statusAlertModal}`) })}
        type={statusAlertModal === 'DELETE' ? 'error' : 'warning'}
        handleClose={() => setIsOpenAlertModal(false)}
        onCancel={{ onClick: () => setIsOpenAlertModal(false), title: t('BUTTON.CANCEL') }}
        onSubmit={{ onClick: statusAlertModal === 'DELETE' ? onDelete : onActive, title: t('BUTTON.SUBMIT') }}
      />
      <SnackbarComponent
        onOpen={isOpenSnack}
        onClose={() => setIsOpenSnack(false)}
        label={labelSnack}
        type={typeSnack}
        transform={`translateX(calc(100vw - 100% - 32px)) translateY(calc(-100vh + 100% + ${window.innerHeight - 50}px))`}
        autoHideTime={3000}
      />
      <Card className="border-0 h-100">
        <HeaderCard text={t('XRAY_FILM_TYPE.TITLE')} />
        <Card.Body>
          <Card.Title className={'mb-0 pl-xl-3'}>
            <Row className="align-items-center">
              <Col md={8}>
                <Row className="flax-row">
                  <Col sm={12} md={6} xl={4} className="pt-2">
                    <InputTextSearch
                      keyInput={'search'}
                      label={t('XRAY_FILM_TYPE.SEARCH')}
                      value={search}
                      onchange={(event) => {
                        setSearch(event.target.value)
                        setPage(1)
                      }}
                      onClear={(event) => {
                        setSearch('')
                        setPage(1)
                      }}
                    />
                  </Col>
                  <Col sm={12} md={6} xl={4} className="pl-md-0 pt-2">
                    <FilterSelect
                      onchange={(event) => {
                        const value = event.target.value
                        if (value) {
                          handleChangeStatus(value)
                          setPage(1)
                        }
                      }}
                      renderValue={() => `${t('STATUS.LABEL')}: ${t(`STATUS.${status}`)}`}
                      label={t('STATUS.LABEL')}
                      selectId="select-status"
                      value={status}
                      labelId="label-status"
                      options={[
                        <MenuItem key="1" value="ALL">
                          {t('STATUS.ALL')}
                        </MenuItem>,
                        <MenuItem key="2" value="ACTIVE">
                          {t('STATUS.ACTIVE')}
                        </MenuItem>,
                        <MenuItem key="3" value="INACTIVE">
                          {t('STATUS.INACTIVE')}
                        </MenuItem>
                      ]}
                    />
                  </Col>
                </Row>
              </Col>
              <Col md={4} className="mt-2 mt-md-auto">
                <div className="pr-xl-2">
                  <ButtonCustom mode="add" disabled={permissions.isCreate.disabled} onClick={() => setIsOpen(true)} textButton={t('XRAY_FILM_TYPE.BUTTON.ADD')} className="w-auto ml-auto d-flex mt-auto" />
                </div>
              </Col>
            </Row>
          </Card.Title>

          <div className={'mt-3 pl-xl-3 pr-xl-2'}>
            <TableCustom
              page={page}
              pageLimit={pageLimit}
              sortType={sortType}
              sortBy={sortBy}
              onSort={onRequestSort}
              setPageLimit={handleChangeRowsPerPage}
              setPage={handleChangePage}
              rowCount={rowCount}
              headCells={headCells}
              rowsData={xrayFilmTypes.map((val, i) => {
                return renderData(val, i)
              })}
            />
          </div>
        </Card.Body>
      </Card>

      <PageModal
        title={xrayFilmTypeId ? t('XRAY_FILM_TYPE.TITLE_UPDATE') : t('XRAY_FILM_TYPE.TITLE_CREATE')}
        size='XS'
        isOpen={isOpen}
        handleClose={resetForm}
        onCancel={{ onClick: resetForm, title: t('XRAY_FILM_TYPE.BUTTON.CANCEL') }}
        onSubmit={{ onClick: xrayFilmTypeId ? submitEdit : submit, title: t('XRAY_FILM_TYPE.BUTTON.SAVE') }}
      >
        <Box display="flex" flexDirection="column" gap="16px">
          {xrayFilmTypeId ? <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography>{t('INPUT.LABEL_STATUS')}</Typography>
            <SwitchButton onChange={() => setXrayFilmTypeStatus(xrayFilmTypeStatus === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE')} checked={xrayFilmTypeStatus === 'ACTIVE' ? true : false} />
          </Box> : ''}
          <TextInput
            onChange={(event) => {
              setXrayFilmTypeName(event.target.value)
              clearErrorMessage()
            }}
            value={xrayFilmTypeName}
            label={t('XRAY_FILM_TYPE.INPUT.XRAY_FILM_TYPE_NAME')}
            helperText={
              errorMessage.XRAY_FILM_TYPE_NAME ||
              errorMessage.IS_DUPLICATE_XRAY_FILM_TYPE_NAME ||
              errorMessage.XRAY_FILM_TYPE_NAME_STRING_BASE ||
              errorMessage.XRAY_FILM_TYPE_NAME_STRING_EMPTY ||
              errorMessage.XRAY_FILM_TYPE_NAME_MAXIMUM_LENGTH ||
              errorMessage.XRAY_FILM_TYPE_NAME_ANY_REQUIRED
            }
            required
          />
        </Box>
      </PageModal>

      {/* <ModalCustom
        title={xrayFilmTypeId ? t('XRAY_FILM_TYPE.TITLE_UPDATE') : t('XRAY_FILM_TYPE.TITLE_CREATE')}
        component={
          <div className="pb-2">
            {xrayFilmTypeId ? (
              <div>
                <Form className="mx-0 mt-0 mb-3 p-0  d-inline-flex w-100">
                  <Form.Label className=" mr-auto">{t('INPUT.LABEL_STATUS')}</Form.Label>
                  <Form.Check type="switch" id="custom-switch" onChange={() => setXrayFilmTypeStatus(xrayFilmTypeStatus === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE')} checked={xrayFilmTypeStatus === 'ACTIVE' ? true : false} style={{ marginLeft: 'auto' }} />
                </Form>
              </div>
            ) : (
              ''
            )}

            <InputTextField
              onchange={(event) => {
                setXrayFilmTypeName(event.target.value)
                clearErrorMessage()
              }}
              value={xrayFilmTypeName}
              label={t('XRAY_FILM_TYPE.INPUT.XRAY_FILM_TYPE_NAME')}
              helperText={
                errorMessage.XRAY_FILM_TYPE_NAME ||
                errorMessage.IS_DUPLICATE_XRAY_FILM_TYPE_NAME ||
                errorMessage.XRAY_FILM_TYPE_NAME_STRING_BASE ||
                errorMessage.XRAY_FILM_TYPE_NAME_STRING_EMPTY ||
                errorMessage.XRAY_FILM_TYPE_NAME_MAXIMUM_LENGTH ||
                errorMessage.XRAY_FILM_TYPE_NAME_ANY_REQUIRED
              }
              required={true}
            />
          </div>
        }
        onReset={resetForm}
        onSubmit={xrayFilmTypeId ? submitEdit : submit}
        textBtnCancel={t('XRAY_FILM_TYPE.BUTTON.CANCEL')}
        textBtnConfirm={t('XRAY_FILM_TYPE.BUTTON.SAVE')}
      /> */}
    </div>
  )
}
